import { isValidJson } from './index';

export const processError = error => {
  if (typeof error !== 'string') {
    error = error.toString();
  }

  try {
    const jsonParsedError = JSON.parse(error);
    return processErrorCode(jsonParsedError);
  } catch (e) {
    return 'INVALID';
  }
};

export const processErrorCode = jsonParsedError => {
  let code = 'INVALID';

  if (Array.isArray(jsonParsedError) && jsonParsedError.length > 0) {
    code = jsonParsedError[0].code || code;
  } else if (typeof jsonParsedError === 'object' && jsonParsedError.code) {
    code = jsonParsedError.code;
  }

  return code;
};

export const getErrorMessage = (error: string, fallbackMessage: string): string => {
  try {
    const parsedError = isValidJson(error) ? JSON.parse(error) : error;

    if (parsedError?.message) {
      return parsedError.message;
    }

    if (parsedError?.error) {
      return parsedError.error;
    }

    for (const key of Object.keys(parsedError)) {
      if (parsedError[key]) {
        return parsedError[key]?.[0]?.message || fallbackMessage;
      }
    }
    return fallbackMessage;
  } catch (e) {
    return fallbackMessage;
  }
};
